module.exports = __webpack_public_path__ + "img/strategic-6.945f326a.png";